module.exports = __webpack_public_path__ + "img/chevron-right.1fce7054.svg";